import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-cream-warm py-24" data-id="element-86">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-88">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-navy-900 mb-4" data-id="element-89">
            The Real Problem
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-90"></div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="prose prose-lg mx-auto text-navy-800" data-id="element-91">
          <p className="text-xl leading-relaxed mb-6" data-id="element-92">
            Living in a constant state of alert is not living. That feeling of
            unease when you think about your retirement, a medical emergency, or
            simply the silence of your home is not a character flaw — it's a
            lack of logistical and emotional infrastructure.
          </p>

          <p className="text-xl leading-relaxed mb-10" data-id="element-93">
            You've tried meditating, you've read generic self-help books, and
            you've listened to advice that makes you feel "behind" in life. But
            none of that addresses the root cause:
          </p>

          <div className="bg-white p-6 sm:p-8 rounded-xl shadow-md border-l-4 border-gold" data-id="element-94">
            <p className="text-2xl font-serif text-navy-900 font-bold m-0" data-id="element-95">
              The lack of a tactical personal security system.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}